import HeaderPortal from "components/portal/header-portal";
import { apiRoot } from "services/src/config";
import { fetchCustomListData } from "components/list/useListQuery";
import { EmptySection1 } from "components/empty";
import ListLoader from "components/list/loader";
import React, { useState } from "react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "ui/components/sheet";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "ui/components/select";
import Icon from "../icon";
import Table from "components/list/table";
import { useEffect } from "react";
import { Button } from "ui/components/button";
import { LIST_FILTER } from "icons";
import { EvtHeader } from "components/header";

import classNames from "classnames";
import ReactList, {
  ReactListPagination,
  ReactListEmpty,
  ReactListInitialLoader,
  ReactListItems,
  ReactListProvider,
  ReactListSearch,
} from "@7span/react-list";
import Search from "./search";
import CommonPagination from "components/list/pagination";
import config from "components/list/react-list";
import { eventBus } from "utils/eventBus";
import { LIST_VERSION } from "./constant";
import useUrlListState from "./use-url-list-state";

const ReactListWrapper = ({
  endPoint,
  columns,
  title,
  info,
  onRowClick = () => { },
  meta = {},
  filters = {},
  perPage = 10,
  rowClassName = "h-10",
  getRowClassName,
  sortBy = "date_created",
  sortOrder = "desc",
  onDataChange = () => { },
  storageKey,
  emptySectionTitle,
  renderFilters,
  children,
  onFiltersChange,
  setState,
  href,
  teleportFilters = false,
  hidePagination = false,
  showSearch = false,
  searchPlaceholder = "Search",
  renderItems,
  renderItemsLoader,
  inlineFilters = false,
  getSubRows,
  permissionEndPoint,
  export: enableExport = false,
  fields,
  type,
  linkProps,
  showIndex = true,
  hideIndex = false,
}) => {
  // Apply ?filters=&search= from URL before ReactList mounts.
  useUrlListState({
    endpoint: endPoint,
    version: storageKey + LIST_VERSION,
    defaultFilters: filters,
  });
  const [isOpen, setIsOpen] = useState(false);
  const updatedConfig = { ...config, requestHandler: fetchCustomListData };

  return (
    <ReactListProvider config={updatedConfig}>
      <ReactList
        title={title}
        info={info}
        endpoint={endPoint}
        perPage={perPage}
        sortBy={sortBy}
        sortOrder={sortOrder}
        version={storageKey + LIST_VERSION}
        meta={meta}
        onRowClick={onRowClick}
        filters={filters}
      >
        {({
          loader,
          response,
          hasActiveFilters,
          setSort,
          setFilters,
          filters: currentFilters,
          clearFilters,
          count,
          sort: { sortBy, sortOrder },
          setPerPage,
          pagination,
          refresh,
        }) => {

          const handleExport = async (e) => {
            e.preventDefault();

            const queryParams = new URLSearchParams();
            queryParams.append("endpoint", endPoint.startsWith('/') ? endPoint : `/${endPoint}`);
            if (fields) {
              queryParams.append("fields", Array.isArray(fields) ? fields.join(",") : fields);
            }
            if (currentFilters) {
              Object.entries(currentFilters).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                  queryParams.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
                }
              });
            }
            if (sortBy) {
              queryParams.append("sort", sortOrder === "desc" ? `-${sortBy}` : sortBy);
            }

            try {
              const response = await apiRoot.get(`export/data?${queryParams.toString()}`);
              if (response.data && response.data.url) {
                window.open(response.data.url, '_blank');
              }
            } catch (error) {
              console.error("Export failed:", error);
            }
          };

          useEffect(() => {
            onFiltersChange?.(currentFilters);
          }, [currentFilters]);

          useEffect(() => {
            if (response) {
              onDataChange(response);
            }
          }, [response]);

          const refreshKey = `${endPoint}${storageKey}`;

          useEffect(() => {
            const handleRefresh = (id) => {
              if (id === refreshKey) {
                refresh();
              }
            };

            eventBus.on("refresh:list", handleRefresh);

            return () => {
              eventBus.off("refresh:list", handleRefresh);
            };
          }, [refresh, refreshKey]);

          return (
            <div className="flex flex-col flex-1">
              {enableExport && (
                <HeaderPortal>
                  <Button onClick={handleExport} variant="default" className="text-sm font-medium h-full">
                    Export
                  </Button>
                </HeaderPortal>
              )}
              {title && (
                <EvtHeader title={title} info={info}>
                  <div className="flex gap-4 items-stretch">
                    {showSearch ? (
                      <ReactListSearch>
                        {(props) => (
                          <Search
                            {...props}
                            searchPlaceholder={searchPlaceholder}
                          />
                        )}
                      </ReactListSearch>
                    ) : null}
                    {renderFilters && !teleportFilters ? (
                      <>
                        {inlineFilters ? (
                          <div>
                            {renderFilters({
                              setIsOpen,
                              filters: currentFilters,
                              setFilters,
                              isOpen,
                              defaultFilters: filters,
                              clearFilters,
                            })}
                          </div>
                        ) : (
                          <Button
                            variant={"outline"}
                            onClick={() => setIsOpen(!isOpen)}
                            className="text-sm font-medium h-full"
                          >
                            <div className="relative">
                              <Icon
                                icon={LIST_FILTER}
                                className="size-5 text-primary-500"
                              />
                              {hasActiveFilters && (
                                <span className="absolute bg-red-500 size-2 top-0 right-0 rounded-full" />
                              )}
                            </div>
                            Filters
                          </Button>
                        )}
                      </>
                    ) : null}
                  </div>
                </EvtHeader>
              )}

              {renderFilters ? (
                teleportFilters ? (
                  <HeaderPortal>
                    {renderFilters({
                      setIsOpen,
                      filters: currentFilters,
                      setFilters,
                      isOpen,
                      defaultFilters: filters,
                      clearFilters,
                    })}
                  </HeaderPortal>
                ) : (
                  !inlineFilters && (
                    <Sheet open={isOpen} onOpenChange={setIsOpen}>
                      <SheetContent className="gap-2">
                        <SheetHeader className="pt-6 px-6 pb-4">
                          <SheetTitle className="text-2xl font-semibold">
                            Filters
                          </SheetTitle>
                        </SheetHeader>
                        <div className="w-full overflow-auto h-full">
                          {renderFilters({
                            setIsOpen,
                            filters: currentFilters,
                            setFilters,
                            isOpen,
                            defaultFilters: filters,
                            clearFilters,
                          })}
                        </div>
                      </SheetContent>
                    </Sheet>
                  )
                )
              ) : null}

              <div
                className={classNames("px-4.5", { "p-0!": renderItemsLoader })}
              >
                <ReactListInitialLoader>
                  {renderItemsLoader ? (
                    renderItemsLoader()
                  ) : (
                    <ListLoader columns={columns} rows={perPage} />
                  )}
                </ReactListInitialLoader>
                <ReactListEmpty>
                  <EmptySection1 title={emptySectionTitle} />
                </ReactListEmpty>
                <ReactListItems>
                  {({ items }) => {
                    if (renderItems) {
                      return renderItems({ items });
                    }
                    const shouldShowIndex = showIndex && !hideIndex;
                    const updatedColumns = shouldShowIndex
                      ? [
                          {
                            id: "#",
                            header: "#",
                            size: 50,
                            cell: ({ row }) => {
                              const page = pagination?.page || 1;
                              const perPage = pagination?.perPage || 10;
                              return (
                                <span>
                                  {(page - 1) * perPage + row.index + 1}
                                </span>
                              );
                            },
                          },
                          ...columns,
                        ]
                      : columns;
                    return (
                      <Table
                        data={items}
                        endPoint={permissionEndPoint || endPoint}
                        columns={updatedColumns}
                        onSort={setSort}
                        onClick={onRowClick}
                        rows={perPage}
                        loader={loader}
                        totals={response?.meta?.totals}
                        setState={setState}
                        href={href}
                        linkProps={linkProps}
                        getSubRows={getSubRows}
                        sortBy={sortBy}
                        sortOrder={sortOrder}
                        rowClassName={rowClassName}
                        getRowClassName={getRowClassName}
                      />
                    );
                  }}
                </ReactListItems>
                {!hidePagination && count > 0 && (
                  <div className="flex justify-between items-center m-6">
                    <div className="flex items-center gap-4">
                      <Select
                        value={String(pagination?.perPage || 10)}
                        onValueChange={(val) => setPerPage(Number(val))}
                      >
                        <SelectTrigger className="w-fit gap-1 h-8 text-sm text-muted-foreground border-none shadow-none bg-transparent hover:bg-muted py-0 px-2 cursor-pointer focus:ring-0">
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="10">10</SelectItem>
                          <SelectItem value="25">25</SelectItem>
                          <SelectItem value="50">50</SelectItem>
                        </SelectContent>
                      </Select>
                      <div className="text-sm text-muted-foreground">
                        Showing {((pagination?.page || 1) - 1) * (pagination?.perPage || 10) + 1} to {Math.min((pagination?.page || 1) * (pagination?.perPage || 10), count)} of {count} entries
                      </div>
                    </div>
                    <ReactListPagination>
                      {(props) => (
                        <CommonPagination
                          {...props}
                          className="justify-end w-max ml-auto mr-0"
                        />
                      )}
                    </ReactListPagination>
                  </div>
                )}
                {typeof children === "function"
                  ? children({
                    filters,
                    data: response,
                    loading: loader?.isLoading || loader?.initialLoading,
                  })
                  : children}
              </div>
            </div>
          );
        }}
      </ReactList>
    </ReactListProvider>
  );
};

export default React.memo(ReactListWrapper);
